import React, { useState, useEffect } from 'react';
import {
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  View,
  ActivityIndicator,
  Platform,
  StyleSheet,
} from 'react-native';

import NumericInput from '../../../common/components/formcomponents/NumericInput';
import { BOHTlbCheckbox } from '../../../common/components/bohtoolbar';

import { createLocation, updateLocation, updateStoreLocation, deleteStoreLocation } from '../../../api/Settings';
import { getPlantationsData } from '../../../api/AllAddress ';
import BasicModalContainer from '../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../common/components/basicmodal/ModalFooter';
import { msgStr } from '../../../common/constants/Message';
import { useAlertModal } from '../../../common/hooks';
import { commonModalStyle } from '../../../common/components/basicmodal';
import Select from '../../../common/components/ui/Select';
import { MultiSelect } from 'react-native-element-dropdown';
import { getBrandsData } from '../../../api/Price';


const AddStoreLocationModal = ({ isModalVisible, Location, setUpdateLocationsTrigger, closeModal }) => {
  const isUpdate = Location ? true : false;

  const { showAlert } = useAlertModal();
  const [ValidMessage, setValidMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [LocationTxt, setLocationTxt] = useState('');
  const [DescriptionTxt, setDescriptionTxt] = useState('');
  const [NameTxt, setNameTxt] = useState('');
  const [AddressLine1Txt, setAddressLine1Txt] = useState('');
  const [AddressLine2Txt, setAddressLine2Txt] = useState('');
  const [CityTxt, setCityTxt] = useState('');
  const [StateTxt, setStateTxt] = useState('');
  const [PostalCodeTxt, setPostalCodeTxt] = useState('');
  const [LatitudeTxt, setLatitudeTxt] = useState(0);
  const [LongitudeTxt, setLongitudeTxt] = useState(0);
  const [isDriveOffLocation, setIsDriveOffLocation] = useState(1);
  const [locationGroup, setLocationGroup] = useState('');
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [locationType, setLocationType] = useState('');
  const [initialBrandMap, setInitialBrandMap] = useState({});
  const [plantations, setPlantations] = useState<any[]>([]);
  const [plantationId, setPlantationId] = useState<number | null>(null);

  useEffect(() => {
    getBrandsData((jsonRes, status, error) => {
      if (status === 200) {
        setBrands(jsonRes.map((item) => ({ label: item.brand, value: item.id })));
      }
    });
    getPlantationsData((jsonRes, status) => {
      if (status === 200 && jsonRes) setPlantations(jsonRes);
    });
  }, []);

  useEffect(() => {
    const street = [AddressLine1Txt, AddressLine2Txt]
      .filter((part) => part && part.trim() !== '')
      .join(', ');
    const cityState = [CityTxt, StateTxt]
      .filter((part) => part && part.trim() !== '')
      .join(', ');
    const lastPart = [cityState, PostalCodeTxt]
      .filter((part) => part && part.trim() !== '')
      .join(' ');

    const fullAddress = [street, lastPart]
      .filter((part) => part && part.trim() !== '')
      .join(', ');

    if (fullAddress.length > 0) {
      setLocationTxt(fullAddress);
    } else {
      setLocationTxt(Location ? Location.location : '');
    }
  }, [AddressLine1Txt, AddressLine2Txt, CityTxt, StateTxt, PostalCodeTxt, Location]);


  useEffect(() => {
    if (isModalVisible) {
      setValidMessage('');
      setLocationTxt(Location ? Location.location : '');
      setDescriptionTxt(Location ? Location.description : '');
      setNameTxt(Location ? Location.name || '' : '');
      setAddressLine1Txt(Location ? Location.address_line1 || '' : '');
      setAddressLine2Txt(Location ? Location.address_line2 || '' : '');
      setCityTxt(Location ? Location.city || '' : '');
      setStateTxt(Location ? Location.state || '' : '');
      setPostalCodeTxt(Location ? Location.postal_code || '' : '');
      setLatitudeTxt(Location ? parseFloat(Location.latitude) : 0);
      setLongitudeTxt(Location ? parseFloat(Location.longitude) : 0);
      setIsDriveOffLocation(Location ? Location.is_driveoff_location : 1);
      setLocationGroup(Location ? Location.location_group || '' : '');
      setLocationType(Location ? Location.location_type || '' : '');
      setPlantationId(Location ? Location.plantation_id || null : null);
      const brandMap =
        Location && Array.isArray(Location.locationStores)
          ? Location.locationStores.reduce((acc, store) => {
              const brandId = store?.brand_id || store?.brands?.id;
              if (brandId !== null && brandId !== undefined) acc[Number(brandId)] = store?.id;
              return acc;
            }, {})
          : {};
      setInitialBrandMap(brandMap);
      setSelectedBrands(Object.keys(brandMap).map((id) => Number(id)));
    }
  }, [isModalVisible, Location]);

  const AddLocationButtonHandler = () => {
    if (!LocationTxt.trim()) {
      setValidMessage(msgStr('emptyField'));
      return;
    }

    setIsLoading(true);

    const brandDiff = { toAdd: [], toRemove: [] } as { toAdd: number[]; toRemove: number[] };

    const payload:any = {
      location: LocationTxt,
      description: DescriptionTxt,
      name: NameTxt,
      address_line1: AddressLine1Txt,
      address_line2: AddressLine2Txt,
      city: CityTxt,
      state: StateTxt,
      postal_code: PostalCodeTxt,
      latitude: LatitudeTxt,
      longitude: LongitudeTxt,
      is_driveoff_location: isDriveOffLocation,
      location_group: locationGroup,
      location_type: locationType,
      plantation_id: plantationId,
    };

    const linkBrands = async (locationId, brandsToLink = selectedBrands) => {
      if (brandsToLink.length > 0) {
        const promises = brandsToLink.map((brandId) => {
          return new Promise((resolve) => {
            const payload = {
              brand_id: brandId,
              location_id: locationId,
              is_default: false,
            };
            updateStoreLocation(payload, (jsonRes, status) => {
              resolve(status);
            });
          });
        });
        await Promise.all(promises);
      }
    };

    const unlinkBrands = async (locationId, brandsToRemove) => {
      if (brandsToRemove.length > 0) {
        const promises = brandsToRemove.map((brandId) => {
          return new Promise((resolve) => {
            const linkId = initialBrandMap[brandId];
            if (!linkId) return resolve(null);
            deleteStoreLocation(linkId, (jsonRes, status) => {
              resolve(status);
            });
          });
        });
        await Promise.all(promises);
      }
    };

    const handleResponse = async (jsonRes, status) => {
      switch (status) {
        case 201:
        case 200:
          if (jsonRes.id || isUpdate) {
            const locationId = isUpdate ? Location.id : jsonRes.id;
            const brandsToLink = isUpdate ? brandDiff.toAdd : selectedBrands;
            await unlinkBrands(locationId, brandDiff.toRemove);
            await linkBrands(locationId, brandsToLink);
          }
          showAlert('success', jsonRes.message);
          setUpdateLocationsTrigger(true);
          closeModal();
          break;
        case 409:
          setValidMessage(jsonRes.error);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          closeModal();
          break;
      }
      setIsLoading(false);
    };

    if (isUpdate) {
      const selectedSet = new Set(selectedBrands);
      const initialBrandIds = Object.keys(initialBrandMap).map((id) => Number(id));
      brandDiff.toAdd = selectedBrands.filter((id) => !initialBrandMap.hasOwnProperty(id));
      brandDiff.toRemove = initialBrandIds.filter((id) => !selectedSet.has(id));
      payload.id = Location.id;
      updateLocation(payload, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    } else {
      createLocation(payload, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    }
  };

  const checkInput = () => {
    if (!LocationTxt.trim()) {
      setValidMessage(msgStr('emptyField'));
    } else {
      setValidMessage('');
    }
  };

  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={isModalVisible}
    >
      <BasicModalContainer>
        <ModalHeader label={`${isUpdate ? 'Update' : 'Add'} Store Location`} closeModal={closeModal} />
        <ModalBody>
          <View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Name</Text>
              <TextInput
                style={styles.input}
                placeholder="Name"
                value={NameTxt}
                onChangeText={setNameTxt}
                placeholderTextColor="#ccc"
              />
            </View>
          </View>

          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Address line 1</Text>
              <TextInput
                style={styles.input}
                placeholder="Address line 1"
                value={AddressLine1Txt}
                onChangeText={setAddressLine1Txt}
                placeholderTextColor="#ccc"
              />
            </View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Address line 2</Text>
              <TextInput
                style={styles.input}
                placeholder="Address line 2"
                value={AddressLine2Txt}
                onChangeText={setAddressLine2Txt}
                placeholderTextColor="#ccc"
              />
            </View>
          </View>

          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>City</Text>
              <TextInput
                style={styles.input}
                placeholder="City"
                value={CityTxt}
                onChangeText={setCityTxt}
                placeholderTextColor="#ccc"
              />
            </View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>State</Text>
              <TextInput
                style={styles.input}
                placeholder="State"
                value={StateTxt}
                onChangeText={setStateTxt}
                placeholderTextColor="#ccc"
              />
            </View>
          </View>

          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Postal code</Text>
              <TextInput
                style={styles.input}
                placeholder="Postal code"
                value={PostalCodeTxt}
                onChangeText={setPostalCodeTxt}
                placeholderTextColor="#ccc"
              />
            </View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Select
                label={"Area/Plantation"}
                options={plantations.map(p => ({ label: p.plantation, value: p.id }))}
                value={plantationId}
                onChange={(newValue) => setPlantationId(newValue ? Number(newValue) : null)}
                placeholder="Select Area/Plantation"
              />
            </View>
          </View>
          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Latitude</Text>
              <NumericInput
                placeholder="Latitude"
                value={LatitudeTxt}
                onChangeText={setLatitudeTxt}
                validMinNumber={-180}
                validMaxNumber={180}
              />
            </View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Longitude</Text>
              <NumericInput
                placeholder="Longitude"
                value={LongitudeTxt}
                onChangeText={setLongitudeTxt}
                validMinNumber={-180}
                validMaxNumber={180}
              />
            </View>
          </View>

          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
               <Text style={styles.label}>Location belongs to Brands</Text>
               <MultiSelect
                 style={styles.input}
                 data={brands}
                 labelField="label"
                 valueField="value"
                 placeholder="Select brands"
                 search
                 searchPlaceholder="Search..."
                 value={selectedBrands}
                 onChange={(item) => {
                   setSelectedBrands(item);
                 }}
                 selectedStyle={{
                   borderRadius: 12,
                   marginTop: 8,
                   marginRight: 8, 
                   backgroundColor: '#e6e6e6',
                   paddingHorizontal: 8, 
                   paddingVertical: 4
                 }}
               />
            </View>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Select
                label={"Location belongs to  "}
                options={[
                  { label: 'Charleston', value: 'charleston' },
                  { label: 'Hilton Head', value: 'hiltonhead' },
                ]}
                value={locationGroup}
                onChange={(newValue) => {
                  setLocationGroup(newValue);
                }}
                placeholder="Select"
              />
            </View>
          </View>
          <View style={[localStyles.inputRow, { marginBottom: 10 }]}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <BOHTlbCheckbox
                style={{ marginLeft: 0 }}
                label={'Drive off location'}
                CheckboxProps={{ value: !!isDriveOffLocation }}
                onPress={() => setIsDriveOffLocation(+!isDriveOffLocation)}
              />
            </View>
          </View>
          <View style={localStyles.inputRow}>
            <View style={[localStyles.inputContainer, { flex: 1 }]}>
              <Text style={styles.label}>Preview</Text>
              <TextInput
                style={[styles.input, styles.inputDisable, styles.textarea, { width: '100%' }]}
                multiline={true}
                numberOfLines={4}
                editable={false}
                placeholder="Location (Auto-generated)"
                value={LocationTxt}
                placeholderTextColor="#ccc"
              />
            </View>
          </View>

          {ValidMessage.trim() != '' && <Text style={styles.message}>{ValidMessage}</Text>}
        </ModalBody>
        <ModalFooter>
          <TouchableOpacity onPress={AddLocationButtonHandler}>
            <Text style={styles.addButton}>{isUpdate ? 'Update' : 'Add'}</Text>
          </TouchableOpacity>
        </ModalFooter>
      </BasicModalContainer>
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
    </Modal>
  );
};

const styles = commonModalStyle;

const localStyles = StyleSheet.create({
  inputRow: {
    flexDirection: 'row',
  },
  inputContainer: {
    marginHorizontal: 4,
  },
});

export default AddStoreLocationModal;
